
import { config } from '@config';

export const getPath = (...paths: Array<string>): string => {
    // Join paths with '/' and remove duplicate slashes
    return [config.basePath, ...paths]
        .join('/')
        .replace(/\/+/g, '/')
        .replace(/([^:]\/)(\/+)/g, '$1');
};

export const isRootPath = (pathname: string): boolean => {
    // Normalize slashes and compare
    const normalize = (p: string): string =>
        p.replace(/\+/g, '/').replace(/([^:]\/)(\/+)/g, '$1');
    return normalize(pathname) === normalize(config.basePath);
};

export const getPathWithoutBase = (pathname: string): string => {
    return pathname.replace(config.basePath, '');
};
